<ul class="sdps-pull-left sdps-list--inline grid-header-icon sdps-hide">
  <li>
    <button type="button">
      <em class="pi pi-clock history-icon" aria-hidden="true"></em> <span>History</span>
    </button>
  </li>
  <li *ngFor="let icon of iconHeaderList">
    <button type="button" [attr.aria-label]="icon.icoName">
      <em [ngClass]="icon.icoClass" aria-hidden="true"></em>
    </button>
  </li>
</ul>
